import { QuestionCreationTaskDetailsProvider } from '@exam-management/question-creation-task-details';
import { useParams } from '@exam-management/router';
import { Flex } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function QuestionCreationItemSetLayout() {
  const { taskId } = useParams('/task-management/question-creation/:taskId');

  return (
    <QuestionCreationTaskDetailsProvider taskId={taskId}>
      <Flex sx={{ flexDirection: 'column', height: '100%' }}>
        <Outlet />
      </Flex>
    </QuestionCreationTaskDetailsProvider>
  );
}
